import axios from "axios";
import { Dispatch } from "redux";
import { RootState } from "api/reducers";
import { Action } from "api/action_types/autocomplete";
import { ActionType } from "api/action_types/autocomplete";
import { AxiosError } from "axios";
import { Action as AuthAction } from "api/action_types/authentication";
import { ActionType as AuthActionType } from "api/action_types/authentication";
import { url_prefix } from "settings";

const autocomplete_url: string = "places_autocomplete";

export const getAutocomplete = (query: string) => {
  return async (dispatch: Dispatch<Action | AuthAction>, getState: () => RootState) => {
    const { user } = getState().authentication;

    const config = {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${user.token}`
      }
    }

    const url = `${url_prefix}${autocomplete_url}/?query_string=${query}`;

    try {
      const { data: predictions } = await axios.post(url, {}, config);

      dispatch({
        type: ActionType.GET_AUTOCOMPLETE_RESULTS,
        predictions
      });
    }
    catch (err) {
      if (err instanceof AxiosError) {
        if (err && err.response && err.response.status === 401) {
          dispatch({
            type: AuthActionType.AUTH_FAILED
          });
        }
      }

    }
  }
}

